import { Link } from 'react-router-dom';
import { usePageTitle } from 'UI/hooks/usePageTitle';
import styles from './HeaderLeft.module.scss';

export function HeaderLeft() {
  const { title } = usePageTitle();

  return (
    <div className={styles.container}>
      <Link className={styles.backButton} to="/" />
      <span className={styles.title}>{title}</span>
    </div>
  );
}
